import { ReactNode } from "react";
import styles from "./Content.module.css";

type ContentProps = {
  children: ReactNode;
};

function Content({ children }: ContentProps) {
  return <div className={styles["root"]}>{children}</div>;
}

export default Content;
